import { render, staticRenderFns } from "./SuperAdminMemberSettings.vue?vue&type=template&id=2ac6d660&scoped=true"
import script from "./SuperAdminMemberSettings.vue?vue&type=script&lang=js"
export * from "./SuperAdminMemberSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac6d660",
  null
  
)

export default component.exports